import { TemplateData, withStyles } from 'vopay';

import styles from './InlineFieldRow.module.scss';

const cn = withStyles(styles);

/** `renderFormElements` override: label and tooltip on the left, control on the right, like the eLinx settings. */
export default function InlineFieldRow(fieldData: TemplateData) {
  return (
    <div className={cn('row')} key={fieldData.fieldName}>
      <div className={cn('label')}>
        {fieldData.label}
        {fieldData.tooltip}
      </div>

      <div>{fieldData.template}</div>
    </div>
  );
}
